<template>
  <b-modal
    :id="`mc-modal-bulk-do-history-${data.index}`"
    ref="mc-modal-bulk-do-history"
    :title="data?.modalTitle"
    class="mc-modal"
    size="md"
    centered
  >
    <div class="card-body p-0">
      <div class="__header">
        <p>
          <span class="__label">{{ data?.labelCreatedOn }}</span>
          <span class="__value">
            {{ formatDateWithTz(data.created_on, 'DD MMM YYYY, HH:mm') }}
          </span>
        </p>
        <p>
          <span class="__label">{{ `Total DO: ` }}</span>
          <span class="__value">{{ items?.length || 0 }}</span>
        </p>
      </div>

      <b-table
        :fields="fields"
        :items="items"
        class="border"
      />
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.close')"
          @click="cancel()"
        />
      </div>
    </template>
  </b-modal>
</template>
<script>
import McButton from "@/components/McButton"
import { formatDateWithTz } from '@/helpers/tzDate'

export default {
  components: {
    McButton,
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  computed: {
    fields() {
      return [
        {
          label: 'No. Pengiriman',
          key: 'number',
        },
      ]
    },
    items() {
      return this.data?.delivery_orders || []
    }
  },
  methods: {
    formatDateWithTz,
  }
}
</script>
<style lang="scss" scoped>
.__header {
  color: $mep-color-text-400;

  .__label {
    font-weight: 400;
  }

  .__value {
    font-weight: 500;
  }
}
</style>